<template>
  <div class="info-time-cont">
    <h1 v-if="!stop.isInTheStop" class="time">
      <span id="time-number">{{ getTime }}</span> min
    </h1>
    <h2 v-if="!stop.isInTheStop">Arrival Time</h2>
    <h2 class="here-msg text-right" v-if="stop.isInTheStop">The shuttle is here</h2>
    <img class="img-fluid van" src="../assets/shuttle.png" />
  </div>
</template>

<script>
import moment from 'moment-timezone';

export default {
  name: "EtaCounter",
  props: {
      stop: Object
  },
  
  computed:{
      getTime: function (){
          let _eta = moment(this.stop.eta);
          let millisecondsToETA = _eta.diff(moment());
          let minutesToETA = Math.round(millisecondsToETA / 60000);
          return minutesToETA;
      }
  },
  
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.info-time-cont {
  text-align: right;
}

</style>


